import { useParams, Link } from "react-router-dom";
import { articles, categories } from "@/mocks/articles";
import SEOHead from "@/components/feature/SEOHead";

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const category = categories.find((c) => c.slug === slug);
  const categoryArticles = articles.filter((a) => a.categorySlug === slug);

  if (!category) {
    return (
      <div className="min-h-screen bg-background-950 flex items-center justify-center">
        <div className="text-center">
          <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4">
            <i className="ri-emotion-sad-line text-5xl text-foreground-600"></i>
          </div>
          <h2 className="text-xl font-bold text-foreground-50 mb-2">
            分类不存在
          </h2>
          <Link
            to="/"
            className="text-sm text-primary-400 hover:text-primary-300 transition-colors duration-200"
          >
            返回首页
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background-950">
      <SEOHead
        title={`${category.name} - 吃瓜黑料在线 | 最新${category.name}爆料实时更新`}
        description={`浏览吃瓜黑料在线${category.name}分类全部内容，实时更新最新${category.name}爆料资讯，追踪网红明星塌房现场。共${categoryArticles.length}条相关内容。`}
        keywords={`${category.name},吃瓜,黑料,爆料,塌房,51吃瓜在线`}
        canonicalUrl={`https://www.chiguaheiliaozx.com/category/${category.slug}`}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "CollectionPage",
            name: `${category.name} - 吃瓜黑料在线`,
            url: `https://www.chiguaheiliaozx.com/category/${category.slug}`,
            description: `浏览吃瓜黑料在线${category.name}分类全部内容。`,
            isPartOf: { "@type": "WebSite", name: "吃瓜黑料在线", url: "https://www.chiguaheiliaozx.com" },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            itemListElement: [
              { "@type": "ListItem", position: 1, name: "首页", item: "https://www.chiguaheiliaozx.com" },
              { "@type": "ListItem", position: 2, name: category.name },
            ],
          }),
        }}
      />
      {/* Category Hero */}
      <section className="relative w-full h-[280px] md:h-[360px] overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20abstract%20cinematic%20background%20with%20dramatic%20red%20and%20dark%20gradients%2C%20mysterious%20atmosphere%2C%20artistic%20composition%2C%20high%20contrast%2C%20deep%20shadows%2C%20film%20noir%20aesthetic%2C%20luxurious%20dark%20texture%2C%20ambient%20lighting&width=1920&height=720&seq=cat-hero&orientation=landscape"
          alt={category.name}
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-background-950"></div>

        <div className="absolute inset-0 flex items-center">
          <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
            <div className="mb-3">
              <nav className="flex items-center gap-1.5 text-xs text-foreground-500">
                <Link
                  to="/"
                  className="hover:text-primary-400 transition-colors duration-200 whitespace-nowrap"
                >
                  首页
                </Link>
                <div className="w-3 h-3 flex items-center justify-center">
                  <i className="ri-arrow-right-s-line text-foreground-600"></i>
                </div>
                <span className="text-foreground-300 whitespace-nowrap">
                  {category.name}
                </span>
              </nav>
            </div>
            <div className="flex items-center gap-3 mb-3">
              <div className="w-10 h-10 flex items-center justify-center bg-primary-500/20 rounded-full">
                <i className={`${category.icon} text-primary-500 text-xl`}></i>
              </div>
              <h1 className="font-heading text-2xl md:text-3xl font-bold text-foreground-50">
                {category.name}
              </h1>
            </div>
            <p className="text-sm text-foreground-400 max-w-lg">
              共 {categoryArticles.length} 条相关爆料，实时更新中
            </p>
          </div>
        </div>
      </section>

      {/* Article List */}
      <section className="w-full max-w-7xl mx-auto px-4 md:px-6 py-10">
        {categoryArticles.length === 0 ? (
          <div className="text-center py-20">
            <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4">
              <i className="ri-inbox-line text-5xl text-foreground-600"></i>
            </div>
            <h3 className="text-lg font-semibold text-foreground-300 mb-2">
              暂无内容
            </h3>
            <p className="text-sm text-foreground-500">
              该分类下还没有爆料内容，请稍后再来
            </p>
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {categoryArticles.map((article) => (
              <Link
                key={article.id}
                to={`/article/${article.slug}`}
                className="group bg-background-900 rounded-lg overflow-hidden cursor-pointer hover:bg-background-800 transition-colors duration-200"
              >
                <div className="relative h-44 overflow-hidden">
                  <img
                    src={article.imageUrl}
                    alt={article.title}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                  {article.isHot && (
                    <div className="absolute top-3 left-3">
                      <span className="px-2 py-0.5 bg-primary-500 text-foreground-50 text-xs rounded-full font-medium whitespace-nowrap">
                        热门
                      </span>
                    </div>
                  )}
                  {article.isNew && (
                    <div className="absolute top-3 right-3">
                      <span className="px-2 py-0.5 bg-accent-500 text-background-950 text-xs rounded-full font-medium whitespace-nowrap">
                        最新
                      </span>
                    </div>
                  )}
                </div>
                <div className="p-4">
                  <h3 className="text-sm font-bold text-foreground-50 mb-2 group-hover:text-primary-400 transition-colors duration-200 line-clamp-2">
                    {article.title}
                  </h3>
                  <p className="text-xs text-foreground-500 line-clamp-2 mb-3">
                    {article.excerpt}
                  </p>
                  <div className="flex items-center gap-3 text-xs text-foreground-600">
                    <span>{article.date}</span>
                    <span className="flex items-center gap-1">
                      <div className="w-3 h-3 flex items-center justify-center">
                        <i className="ri-eye-line"></i>
                      </div>
                      {article.views >= 10000
                        ? `${(article.views / 10000).toFixed(0)}万`
                        : article.views}
                    </span>
                    <span className="flex items-center gap-1">
                      <div className="w-3 h-3 flex items-center justify-center">
                        <i className="ri-message-2-line"></i>
                      </div>
                      {article.comments}
                    </span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )}

        {/* Other Categories */}
        <div className="mt-14">
          <h3 className="text-sm font-semibold text-foreground-400 mb-4">
            浏览其他分类
          </h3>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3">
            {categories
              .filter((c) => c.slug !== slug)
              .map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="flex items-center gap-3 p-3 bg-background-900 hover:bg-background-800 border border-background-700 rounded-lg transition-colors duration-200 cursor-pointer"
                >
                  <div className="w-7 h-7 flex items-center justify-center bg-primary-500/10 rounded-full flex-shrink-0">
                    <i className={`${cat.icon} text-primary-500 text-sm`}></i>
                  </div>
                  <div className="min-w-0">
                    <div className="text-xs font-medium text-foreground-300 whitespace-nowrap">
                      {cat.name}
                    </div>
                    <div className="text-[10px] text-foreground-600">
                      {cat.count}条
                    </div>
                  </div>
                </Link>
              ))}
          </div>
        </div>
      </section>
    </div>
  );
}